import { B400, N0 } from '@atlaskit/theme/colors';
import { generateTheme } from './themeGenerator';
import { DEFAULT_THEME_NAME } from './defaultTheme';
export var atlassianTheme = generateTheme({
    name: DEFAULT_THEME_NAME,
    backgroundColor: N0,
    highlightColor: B400,
});
export var defaultTheme = atlassianTheme;
//# sourceMappingURL=themes.js.map